import { TenantlessBaseEntity, WithTenantlessBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { Executor, FromSchema } from '@40seas/entities/common';
import { AddressMatchSearchResult, AddressMatchSearchResultSchema } from './address.match.search.result.entity';

export const AddressMatchSchema = WithTenantlessBaseEntitySchema(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore - Fix TS FS-3199
    z.object({
        searchQuery: z.string(),
        searchResult: AddressMatchSearchResultSchema.nullish(),
    }),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore - Fix TS FS-3199
).strict();

export class AddressMatch extends FromSchema(AddressMatchSchema) implements TenantlessBaseEntity {
    id: string;
    searchQuery: string;
    searchResult: AddressMatchSearchResult;
    createdBy?: Executor;
    createdAt: Date;
    updatedAt: Date;
}
